<template>
  <div>
    <v-row align="center" justify="center" dense class="mb-4">
      <v-col cols="1"/>
      <v-col cols="5"
             class="py-10
                 fill-height
                 d-flex
                 flex-column
                 justify-center
                 align-center">

        <img src="@/assets/credisolvelogo.png" height="62" style="margin-left: 5%">

      </v-col>
      <v-col cols="5"
             class="py-10 fill-height d-flex flex-column justify-center align-center">

        <a href="https://maforigroup.co.za/contact" target="_blank" class="pl-16">
          <img src="@/assets/maforilogo.png" height="75px" width="75px">
        </a>
      </v-col>
      <v-col cols="1"/>
    </v-row>
    <v-row align="center" justify="center" dense class="mb-4">
      <v-col cols="10"
             xl="6"
             lg="6"
             md="6"
             class="fill-height justify-center align-center text-left">
        For any application related queries please send an email to
        <a :href="queriesEmail">{{ this.contactDetails.queriesEmail }}</a>
        or <a :href="whatsapp" target="_blank">tap/click here</a> to send us a WhatsApp message
      </v-col>

    </v-row>
  </div>

</template>

<script>
export default {
  name: "SiteHeader",
  props: ['contactDetails'],
  getContactDetails() {
    this.$store
        .dispatch("experian/getContactDetails")
        .then(
            (result) => {
              this.contactDetails = result;
              console.log(result);
            },
            (error) => this.notify(error.response.data, "error")
        );
  },
  computed: {
    queriesEmail() {
      return 'mailto:' + this.contactDetails.queriesEmail;
    },
    whatsapp() {
      return `https://api.whatsapp.com/send?phone=${this.contactDetails.whatsAppNumber}&text=Hi%2C%20I%20would%20like%20assistance.`;
    }
  }
}
</script>

<style scoped>

</style>
